export default {
  getFooterMenu(language) {
    let menu;
    switch (language) {
      case 'fr':
        menu = [
          {
            title: 'Confidentialité',
            path: 'https://www.fraserinstitute.org/fr/confidentialit',
            target: '_blank'
          },
          {
            title: 'Contactez-nous',
            path: 'https://www.fraserinstitute.org/fr/contactez-nous',
            target: '_blank'
          },
          {title: 'droits d\'auteur', path: '/copyright'},
        ];
        break;
      default:
        menu = [
          {
            title: 'Privacy Policy',
            path: 'https://www.fraserinstitute.org/privacy-policy',
            target: '_blank'
          },
          {
            title: 'Contact Us',
            path: 'https://www.fraserinstitute.org/contact',
            target: '_blank'
          },
          {title: 'Copyright', path: '/copyright'},
        ];
        break;
    }
    // TODO: Must change to real repository (drupal) to get menus
    return menu;
  },
  getFooterText(language) {
    switch (language) {
      case 'fr':
        return "Ces classements scolaires sont un programme du Fraser Institute.";
      default:
        return "These school rankings are a program of the Fraser Institute.";
    }
  }
}
